module.exports = {
  adminApiUrl:
    process.env.REACT_APP_ADMIN_API_URL ||
    'http://192.168.3.1:8000/graphql_admin/',
  apiUrl: process.env.REACT_APP_API_URL || 'http://192.168.3.1:8000/graphql/',
  productionUrl: process.env.PRODUCTION_URL || 'https://www.revolico.com',
  publicImageUrl:
    process.env.REACT_APP_PUBLIC_IMAGE_URL || 'http://www.image-url.com',
  localStorageAuthKey: 'auth-token',
  defaultNumberOfRows: 50,
  numberOfRowsOptions: [3, 5, 20, 25, 50, 100],
  userRanks: { STAFF: 'STAFF', ADMIN: 'ADMIN', USER: 'USER' },
  userKinds: {
    AGENCY: 'AGENCY',
    USER: 'USER',
    USER_AGENCY: 'USER_AGENCY',
    AGENCY_CLIENT: 'AGENCY_CLIENT',
  },
  cardProvider: { MOLLIE: 'MOLLIE', TROPIPAY: 'TROPIPAY' },
  leads: { REVOLICO: 'REVOLICO', SELLER: 'SELLER' },
  agencyPaymentMethod: {
    CASH: 'CASH',
    CREDIT_CARD: 'CREDIT_CARD',
    CRYPTO: 'CRYPTO',
  },
  contactInfoValues: {
    EMAIL_PHONE: 'EMAIL_PHONE',
    PHONE: 'PHONE',
    EMAIL: 'EMAIL',
  },
  inboxTabValues: {
    TODAY: 'today',
    YESTERDAY: 'yesterday',
    LAST_WEEK: 'last_week',
    PREVIOUS: 'previous',
  },
  reviewReportStatus: {
    OPEN: 'OPEN',
    RESOLVED: 'RESOLVED',
    DISMISSED: 'DISMISSED',
  },
  reviewReportReasons: {
    OFFENSIVE: 'OFFENSIVE',
    SPAM: 'SPAM',
    FRAUD: 'FRAUD',
    FAKE_IDENTITY: 'FAKE_IDENTITY',
    IRRELEVANT: 'IRRELEVANT',
    OTHER: 'OTHER',
  },
  flags: {
    offensive: { name: 'prohibido-ofensivo', value: 'PROHIBIDO_OFENSIVO' },
    spam: { name: 'repetido-spam', value: 'REPETIDO_SPAM' },
    classified: { name: 'mal-categorizado', value: 'MAL_CATEGORIZADO' },
    scam: { name: 'estafa-enganno', value: 'ESTAFA' },
    joke: { name: 'falso-broma', value: 'FALSO_BROMA' },
  },
  adStatus: {
    PENDING_VERIFICATION: 'PENDING_VERIFICATION',
    PENDING_PROCESSING: 'PENDING_PROCESSING',
    PROCESSING: 'PROCESSING',
    TO_REVIEW: 'TO_REVIEW',
    PUBLISHED_BY_MODERATOR: 'PUBLISHED_BY_MODERATOR',
    PUBLISHED_BY_PROCESSOR: 'PUBLISHED_BY_PROCESSOR',
    UNPUBLISHED_BY_MODERATOR: 'UNPUBLISHED_BY_MODERATOR',
    UNPUBLISHED_BY_PROCESSOR: 'UNPUBLISHED_BY_PROCESSOR',
    UNPUBLISHED_BY_USER: 'UNPUBLISHED_BY_USER',
    EXPIRED: 'EXPIRED',
    UNPUBLISHED_BY_USER_DELETED: 'UNPUBLISHED_BY_USER_DELETED',
    UNPUBLISHED_BY_USER_BLOCKED: 'UNPUBLISHED_BY_USER_BLOCKED',
  },
  reviewStatus: {
    PENDING_PROCESSING: 'PENDING_PROCESSING',
    PROCESSING: 'PROCESSING',
    PUBLISHED: 'PUBLISHED',
    UNPUBLISHED: 'UNPUBLISHED',
    TO_REVIEW: 'TO_REVIEW',
    DELETED: 'DELETED',
  },
  paidAdStatus: {
    PENDING: 'PENDING',
    CANCELLED: 'CANCELLED',
    PAUSED: 'PAUSED',
    SCHEDULED: 'SCHEDULED',
    RUNNING: 'RUNNING',
    COMPLETED: 'COMPLETED',
    NO_CREDIT: 'NO_CREDIT',
  },
  paymentStatus: {
    PENDING: 'PENDING',
    PAYED: 'PAYED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED',
    REFUNDED: 'REFUNDED',
    PENDING_REFUND: 'PENDING_REFUND',
    FAILED_REFUND: 'FAILED_REFUND',
    PARTIAL_REFUNDED: 'PARTIAL_REFUNDED',
    TOTAL_REFUNDED: 'TOTAL_REFUNDED',
    UNRESOLVED: 'UNRESOLVED',
  },
  paymentTypes: {
    MOLLIE: 'MOLLIE',
    COINBASE: 'COINBASE',
  },
  creditTypes: {
    INCREMENT: 'INCREMENT',
    DECREMENT: 'DECREMENT',
  },
  orderTypes: {
    CREDIT: 'CREDIT',
    PAIDAD: 'PAIDAD',
  },
  paidAdCurrency: {
    USD: 'USD',
    CUP: 'CUP',
  },
  frequencies: {
    EIGHTHOURS: {
      years: 0,
      months: 0,
      days: 0,
      hours: 8,
      minutes: 0,
      seconds: 0,
    },
    TWOHOURS: {
      years: 0,
      months: 0,
      days: 0,
      hours: 2,
      minutes: 0,
      seconds: 0,
    },
    FOURHOURS: {
      years: 0,
      months: 0,
      days: 0,
      hours: 4,
      minutes: 0,
      seconds: 0,
    },
    TWELVEHOURS: {
      years: 0,
      months: 0,
      days: 0,
      hours: 12,
      minutes: 0,
      seconds: 0,
    },
    ONEMINUTES: {
      years: 0,
      months: 0,
      days: 0,
      hours: 0,
      minutes: 1,
      seconds: 0,
    },
  },
  schedules: {
    FROM8AM_TO12AM: 'FROM8AM_TO12AM',
    FROM12AM_TO12AM: 'FROM12AM_TO12AM',
  },
  pendingReasonOptions: {
    AD_UNREVIEWED: 'AD_UNREVIEWED',
    AD_UNPUBLISHED: 'AD_UNPUBLISHED',
  },
  defaultProcessorListFilters: {
    listName: 'all',
    group: 'all',
  },
  matchedRules: {
    REVIEW_BOT_SCORE: { key: 'REVIEW BOT SCORE', value: 'review_bot_score' },
    BLOCK_SIMILARITY_SCORE: {
      key: 'BLOCK SIMILARITY SCORE',
      value: 'block_similarity_score',
    },
    BLOCK_SIMILARITY_SCORE_REINSERT: {
      key: 'BLOCK SIMILARITY SCORE REINSERT',
      value: 'block_similarity_score_reinsert',
    },
    REVIEW_SIMILARITY_SCORE: {
      key: 'REVIEW SIMILARITY SCORE',
      value: 'review_similarity_score',
    },
    REVIEW_SIMILARITY_SCORE_REINSERT: {
      key: 'REVIEW SIMILARITY SCORE REINSERT',
      value: 'review_similarity_score_reinsert',
    },
    BLOCK_EXACT_MATCH: { key: 'BLOCK EXACT MATCH', value: 'block_exact_match' },
    BLOCK_EXACT_MATCH_REINSERT: {
      key: 'BLOCK EXACT MATCH REINSERT',
      value: 'block_exact_match_reinsert',
    },
    REVIEW_IP_RATE_LIMIT: {
      key: 'REVIEW IP RATE LIMIT',
      value: 'review_ip_rate_limit',
    },
    BLOCK_IP_RATE_LIMIT: {
      key: 'BLOCK IP RATE LIMIT',
      value: 'block_ip_rate_limit',
    },
    BLOCK_BOT_SCORE: { key: 'BLOCK BOT SCORE', value: 'block_bot_score' },
    BLOCK_BOT_SCORE_RELATED: {
      key: 'BLOCK BOT SCORE RELATED',
      value: 'block_bot_score_related',
    },
    REVIEW_BOT_SCORE_RELATED: {
      key: 'REVIEW BOT SCORE RELATED',
      value: 'review_bot_score_related',
    },
    REVIEW_FLAGGED_FREQUENCY: {
      key: 'REVIEW_FLAGGED_FREQUENCY',
      value: 'review_flagged_frequency',
    },
    BLOCK_FLAGGED_FREQUENCY: {
      key: 'BLOCK FLAGGED FREQUENCY',
      value: 'block_flagged_frequency',
    },
    REVIEW_FLAGGED_COUNT: {
      key: 'REVIEW FLAGGED COUNT',
      value: 'review_flagged_count',
    },
    BLOCK_FLAGGED_COUNT: {
      key: 'BLOCK FLAGGED COUNT',
      value: 'block_flagged_count',
    },
    ALLOW_IP: { key: 'ALLOW IP', value: 'allow_ip' },
    BLOCK_IP: { key: 'BLOCK IP', value: 'block_ip' },
    REVIEW_IP: { key: 'REVIEW IP', value: 'review_ip' },
    ALLOW_EMAIL: { key: 'ALLOW EMAIL', value: 'allow_email' },
    BLOCK_EMAIL: { key: 'BLOCK EMAIL', value: 'block_email' },
    REVIEW_EMAIL: { key: 'REVIEW EMAIL', value: 'review_email' },
    ALLOW_PHONE: { key: 'ALLOW PHONE', value: 'allow_phone' },
    BLOCK_PHONE: { key: 'BLOCK PHONE', value: 'block_phone' },
    REVIEW_PHONE: { key: 'REVIEW PHONE', value: 'review_phone' },
    BLOCK_PHRASES: { key: 'BLOCK PHRASES', value: 'block_phrases' },
    REVIEW_PHRASES: { key: 'REVIEW PHRASES', value: 'review_phrases' },
    REVIEW_UNPUBLISHED: {
      key: 'REVIEW UNPUBLISHED',
      value: 'review_unpublished_ad',
    },
    REVIEW_DUPLICATED_IMAGES: {
      key: 'REVIEW DUPLICATED IMAGES',
      value: 'review_duplicated_images',
    },
    BLOCK_DUPLICATED_IMAGES: {
      key: 'BLOCK DUPLICATED IMAGES',
      value: 'block_duplicated_images',
    },
    REVIEW_DUPLICATED_IMAGES_REINSERT: {
      key: 'REVIEW DUPLICATED IMAGES REINSERT',
      value: 'review_duplicated_images_reinsert',
    },
    BLOCK_DUPLICATED_IMAGES_REINSERT: {
      key: 'BLOCK DUPLICATED IMAGES REINSERT',
      value: 'block_duplicated_images_reinsert',
    },
    REVIEW_DUPLICATED_MAIN_IMAGE: {
      key: 'REVIEW DUPLICATED MAIN IMAGE',
      value: 'review_duplicated_main_image',
    },
    BLOCK_USER_INSERT_RATE_LIMIT: {
      key: 'BLOCK USER INSERT RATE LIMIT',
      value: 'block_user_insert_rate_limit',
    },
    BLOCK_USER_UPDATE_ADS_RATE_LIMIT: {
      key: 'BLOCK USER UPDATE ADS RATE LIMIT',
      value: 'block_user_update_ads_rate_limit',
    },
    BLOCK_USER_UPDATE_AD_RATE_LIMIT: {
      key: 'BLOCK USER UPDATE AD RATE LIMIT',
      value: 'block_user_update_ad_rate_limit',
    },
    REVIEW_USER_INSERT_RATE_LIMIT: {
      key: 'REVIEW USER INSERT RATE LIMIT',
      value: 'review_user_insert_rate_limit',
    },
    REVIEW_USER_UPDATE_ADS_RATE_LIMIT: {
      key: 'REVIEW USER UPDATE ADS RATE LIMIT',
      value: 'review_user_update_ads_rate_limit',
    },
    REVIEW_USER_UPDATE_AD_RATE_LIMIT: {
      key: 'REVIEW USER UPDATE AD RATE LIMIT',
      value: 'review_user_update_ad_rate_limit',
    },
    REVIEW_CATEGORY: {
      key: 'REVIEW CATEGORY',
      value: 'review_category',
    },
  },
  flashMessages: {
    EXTENDED_WITH_PROMO: 'extended_with_promo',
  },
  adCurrencies: {
    CUP: 'CUP',
    USD: 'USD',
    MLC: 'MLC',
  },
  rules: {
    SIMILARITY: 'similarity',
    SIMILARITY_REINSERT: 'similarity_reinsert',
    IP_RATE_LIMIT: 'ip_rate_limit',
    BOT_SCORE_RELATED: 'bot_score_related',
    FLAGGED_FREQUENCY: 'flagged_frequency',
    FLAGGED_COUNT: 'flagged_count',
    DUPLICATED_IMAGES: 'duplicated_images',
    USER_RATE_LIMIT: 'user_rate_limit',
    REVIEW_CATEGORY: 'review_category',
  },
  categoriesWithRequiredMunicipality: [100],
  processorRulesType: {
    ALLOW: 'ALLOW',
    BLOCK: 'BLOCK',
    REVIEW: 'REVIEW',
  },
  processorRulesActions: {
    INSERT: 'INSERT',
    UPDATE: 'UPDATE',
    FLAGGED: 'FLAGGED',
  },
  processorRulesStatus: {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
    DELETED: 'DELETED',
  },
  processorTargets: {
    ADS: 'ADS',
    REVIEWS: 'REVIEWS',
  },
  notesEntities: {
    AD: 'AD',
    EXPIRED_AD: 'EXPIRED_AD',
  },
  exchangeRateStatus: {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
  },
  exchangeRateCurrencies: {
    USD: 'USD',
    CUP: 'CUP',
    EUR: 'EUR',
  },
  currencyFilterStatus: {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
  },
  locationScopes: {
    NATIONAL: 'NATIONAL',
    PROVINCIAL: 'PROVINCIAL',
    MUNICIPAL: 'MUNICIPAL',
  },
  paidAdTypes: {
    AUTO_PAID_AD: 'AUTO_PAID_AD',
    PROMOTED_AD: 'PROMOTED_AD',
  },
  promotedAdPackagesStatus: {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
  },
  creditBundlesStatus: {
    CREATED: 'CREATED',
    STARTED: 'STARTED',
    COMPLETED: 'COMPLETED',
    EXPIRED: 'EXPIRED',
    CANCELLED: 'CANCELLED',
  },
  phoneTypes: {
    LANDLINE: 'LANDLINE',
    CELLPHONE: 'CELLPHONE',
  },
  phoneWhatsapp: {
    FIRST_PHONE: 'FIRST_PHONE',
    SECOND_PHONE: 'SECOND_PHONE',
  },
};
